import { digger } from '@cbre/digger';
import { simpleValueValidation } from '@miq/utils';

function getLandlord(record) {
  const officeUsagesPath = `usages[ref_property_usage_type_desc='Office']`;
  const legalOwnerPath = `company_contact_role_addresses[role_desc='Legal Owner'].party_organization_display_name`;
  const fullPath = `${officeUsagesPath}.${legalOwnerPath}`;
  const landlordValue = digger(record.data, fullPath);
  return simpleValueValidation(landlordValue) ? landlordValue : '-';
}

export const emeaLandlordDisplayFunctions = {
  418: {
    // 418 - Landlord (Poland & Finland)
    displayFn: getLandlord,
  },
  428: {
    // 428 - Landlord (Italy)
    displayFn: getLandlord,
  },
  505: {
    // 505 - Landlord (Norway)
    displayFn: getLandlord,
  },
  515: {
    // 515 - Landlord (Norway)
    displayFn: getLandlord,
  },
  495: {
    // 495 - Landlord (Sweden)
    displayFn: getLandlord,
  },
};
